import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import 'chartjs-plugin-labels';
import { ReportComponentService } from '../reports-component.service';
@Component({
  selector: 'app-detail-content',
  templateUrl: './detail-content.component.html',
  styleUrls: ['./detail-content.component.scss']
})
export class DetailContent implements OnInit {

  @Input() dataReport: any
  isLoading = false;
  dtOptions: DataTables.Settings = {};
  title_report = "Chi tiết nội dung theo chủ đề";
  posts = [];
  dataTableShow = false;
  constructor(private reportComponentService: ReportComponentService) {
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: false,
      searching: false,
      paging: false,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: '',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
    };
  }

  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {
    this.posts = [];    
    this.dataTableShow = false;
    if (this.dataReport && this.dataReport["report_title"]) {
      this.title_report = this.dataReport["report_title"];
    }
    if (this.dataReport && this.dataReport.data && this.dataReport['data'].filter) {
      this.isLoading = true;
      if(this.dataReport['data'].filter.length == 1) {
        this.reportComponentService.getRecentPost(this.dataReport['data'].filter[0]).subscribe(
          res => {
            this.isLoading = false;
            this.posts = res.data.hits.hits;
            this.dataTableShow = true;
          }
        );
      } 
      if(this.dataReport['data'].filter.length == 2) {
        this.reportComponentService.getRecentPost(this.dataReport['data'].filter[0]).subscribe(
          res1 => {
            this.reportComponentService.getRecentPost(this.dataReport['data'].filter[1]).subscribe(
              res2 => {
                this.isLoading = false;
                this.posts = [...res1.data.hits.hits,...res2.data.hits.hits];
                this.dataTableShow = true;
              }
            );
          }
        );
      }
    }
  }

}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/detail-content/detail-content.component.ts